export default __webpack_public_path__ + "static/media/Group 5268.96676c6e.svg";